export default [
  {
    leistungstext: "Personen-, Sach- und Vermögensschäden",
    infoText:
      "Übernahme von Schadenersatzansprüchen für beschädigte Sachen oder finanzielle Schäden eines Dritten bzw. für Schäden an Personen.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Schneeräum- und Bestreuungsrisiko",
    infoText: "Schadenersatzansprüche durch unzureichendes Räumen und Streuen der Grundstücksflächen.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Sachschäden durch allmähliche Einwirkung z. B. durch Temperatur oder Feuchtigkeit ",
    infoText:
      "Allmählichkeitsschäden entstehen, oftmals unbemerkt, über einen längeren Zeitraum und können teilweise hohe Kosten verursachen. Beispielsweise sinkt infolge von Erdarbeiten ein angrenzendes Gebäude allmählich ab und infolgedessen entstehen schwerwiegende Schäden an mehreren Wohneinheiten.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Bauherrenrisiko bis zu einer Bausumme von (inkl. Eigenbauleistungen bis 100.000 €)",
    infoText:
      "Übernahme der gesetzlichen Haftpflicht als Bauherr oder Unternehmer von Bauarbeiten. Eigenbauleistungen sind bis 100.000 € abgesichert.",
    leistungen: ["250.000 €", "500.000 €"],
  },
  {
    leistungstext: "Einschluss der Haftpflicht als Bauleiter und Planer bis 50.000 € Bausumme",
    infoText:
      "Wenn Ihr Kunde selbst als Bauleiter oder Planer tätig ist, sind beauftragte Bautätigkeiten ebenfalls abgesichert.",
    leistungen: ["Nein", "Ja"],
  },
  {
    leistungstext: "Schäden an fremden Sachen, die geliehen, geleast, gepachtet oder gemietet werden",
    infoText: "Ihr Kunde nutzt z.B. den Aufsitzrasenmäher eines Nachbarn und dieser wird beschädigt.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Gewässerschadenrisiko eines ober- oder unterirdischen Öltanks",
    infoText: "Gewässerschäden durch einen Öltank, unabhängig vom Aufstellort.",
    leistungen: ["10.000 Liter", "Ja"],
  },
  {
    leistungstext: "Photovoltaikanlagen",
    infoText:
      "Mitversichert sind die Verkehrssicherungspflicht sowie die Einspeisung von Strom als Besitzer einer Photovoltaikanlage. Es gibt keine Kapazitätsbegrenzung.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext: "Vorsorgeversicherung für neue Risiken",
    infoText:
      "Beitragsfreie Mitversicherung einer hinzukommenden Wohn- oder Gewerbeeinheit bis zur nächsten Beitragsrechnung (Hauptfälligkeit)",
    leistungen: ["1 Mio. €", "Ja"],
  },
  {
    leistungstext: "Forderungsausfall für Mietsachschäden bis 100.000 € ",
    infoText: "Übernahme von uneinbringlichen Schadenersatzforderungen gegenüber einem Mieter",
    leistungen: ["Ja mit Selbstbehalt 10 % des Schadens (mind. 500 €)", "Ja"],
  },

  {
    leistungstext: "Erweiterte Forderungsausfalldeckung bis 100.000 €",
    infoText:
      "Schäden durch Dritte (z.B. Handwerker) werden im Rahmen der erweiterten Forderungsausfalldeckung ersetzt",
    leistungen: ["Nein", "Ja"],
  },
  {
    leistungstext: "Summen- und Bedingungsdifferenzdeckung vor Vertragsbeginn",
    infoText:
      "Ihr Kunde profitiert von den bei uns zusätzlich abgeschlossenen Leistungen schon vor Vertragsbeginn, sofern die Leistungen des Vorversicherers nicht ausreichen",
    leistungen: ["12 Monate", "15 Monate"],
  },
  {
    leistungstext: "Schadenübernahme bei unklaren Zuständigkeiten wegen eines Versicherungswechsels",
    infoText: "Sind die Zuständigkeiten nicht klar, leisten wir im Schadenfall. Die weitere Klärung übernehmen wir.",
    leistungen: ["Ja", "Ja"],
  },
  {
    leistungstext:
      "Ansprüche der Wohnungseigentümer, Teileigentümer und Verwalter untereinander (nur Tarifvariante WEG gesamt)",
    infoText: "",
    leistungen: ["Nein", "Ja"],
  },
  {
    leistungstext: "Best-Leistungs- und Besitzstandsgarantie",
    infoText:
      "Über die Best-Leistungs-Garantie erhalten Ihre Kunden automatisch den besten Schutz am Markt. Mit der Besitzstandsgarantie garantieren wir eventuell beim unmittelbaren Vorversicherer vorhandene Leistungsklauseln ebenfalls.",
    leistungen: ["Nein", "Ja"],
  },
];
